import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { queryClient } from '@/lib/react-query/queryClient';
import { coordinationEndpoints } from '@/modules/coordination/constants';
import { coordinationQueryKeys } from '@/modules/coordination/queries/queryKeys';

export const useApproveCoordinationActionMutation = (
  jobId: string,
  coordinationProcessId: string,
) => {
  return useMutation({
    mutationFn: async ({
      coordinationActionId,
    }: {
      coordinationActionId: string;
    }) => {
      const { data } = await fetchClient.POST(
        coordinationEndpoints.approveAction,
        {
          params: { path: { coordinationActionId } },
        },
      );
      return data;
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: coordinationQueryKeys.processDetail(
          jobId,
          coordinationProcessId,
        ),
      });
      queryClient.invalidateQueries({
        queryKey: coordinationQueryKeys.processes(jobId),
      });
    },
  });
};
